import * as types from '../services/EquityTypeActionType';

const initialState = {
    equityTypeDropdown: [],
    equityTypeLoading: false,
    equityTypeError: null,
};

function equityTypeReducer(state = initialState, action) {
    switch (action.type) {
        case types.GET_EQUITY_TYPE_DROPDOWN_REQUEST:
            return { ...state, equityTypeLoading: true, equityTypeError: null };
        case types.GET_EQUITY_TYPE_DROPDOWN_SUCCESS:
            return { ...state, equityTypeLoading: false, equityTypeDropdown: action.payload };
        case types.GET_EQUITY_TYPE_DROPDOWN_FAILURE:
            return { ...state, equityTypeLoading: false, equityTypeError: action.payload };
        default:
            return state;
    }
}

export default equityTypeReducer;
